class User{

    constructor(){
            this.id=null;
            this.phone=null;
            this.fnamelname=null;
            this.img=null;
            this.homenumber=null;
            this.balance=null;
            this.countUnreadMessages=null;
            this.blockpey5=null;
            this.buyer=null;
            this.city_name=null;
            this.debit=null;
            this.city_id=null;
    }

    setData(json){
            this.id=json.id;
            this.phone=json.phone;
            this.fnamelname=json.fnamelname;
            this.img=json.img;
            this.homenumber=json.home_number;
            this.balance=json.balance;
            this.countUnreadMessages=json.countUnreadMessages;
            this.blockpey5=json.blockpey5;
            this.buyer=json.buyer;
            this.city_name=json.city_name;
            this.debit=json.debit;
            this.city_id=json.city_id;
    }

}

export default User;